import React, { useState, useEffect } from 'react';
import { useGLTF } from '@react-three/drei';

export const TrafficLight = ({ direction, trafficLightStatus }) => {
    const [modelPath, setModelPath] = useState("/models/trafficlight.glb");

    useEffect(() => {
        let interval;

        if (trafficLightStatus === "FASILALIKIRMIZI") {
            let toggle = false;
            interval = setInterval(() => {
                setModelPath(toggle ? "/models/blinkingNone.glb" : "/models/blinkingRed.glb");
                toggle = !toggle;
            }, 1000);
        } else if (trafficLightStatus === "FASILALISARI") {
            let toggle = false;
            interval = setInterval(() => {
                setModelPath(toggle ? "/models/blinkingNone.glb" : "/models/blinkingYellow.glb");
                toggle = !toggle;
            }, 1000);
        } else {
            setModelPath(trafficLightStatus === "KIRMIZI"
                ? "/models/trafficlightkırmızı.glb"
                : "/models/trafficlight.glb"
            );
        }

        return () => clearInterval(interval);
    }, [trafficLightStatus]);

    const { scene } = useGLTF(modelPath);
    const trafficLightPositions = direction === 'forward' ? [{ x: -4, z: 10 }] : [{ x: 4, z: -10 }];
    const rotation = direction === "forward" ? Math.PI : 0;
    const trafficLightModel = scene.clone();

    return (
        <group>
            {trafficLightPositions.map((pos, i) => (
                <group key={i} position={[pos.x, 0, pos.z]} rotation={[0, rotation, 0]}>
                    <primitive
                        object={trafficLightModel.clone()}
                        scale={[-2.5, 2.5, 2.5]}
                        castShadow
                        receiveShadow
                    />
                </group>
            ))}
        </group>
    );
};

// Preload models
useGLTF.preload("/models/trafficlightkırmızı.glb");
useGLTF.preload("/models/trafficlight.glb");
useGLTF.preload("/models/blinkingRed.glb");
useGLTF.preload("/models/blinkingYellow.glb");
useGLTF.preload("/models/blinkingNone.glb");
